import { render, staticRenderFns } from "./NavBarMenu.vue?vue&type=template&id=b2d982d6&"
import script from "./NavBarMenu.vue?vue&type=script&lang=js&"
export * from "./NavBarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports